import { atomEffect } from "jotai-effect";
import { atomFamily } from "jotai/utils";

import { Logger } from "@moment/logging";

import { makeMdPageConnectPresenceCommand } from "../reboot/utils";
import { $editorStateConnection } from "./editor-state.atom";

const logger = new Logger("presence-connection.atom");

/**
 * Effect that manages the presence connection lifecycle for a given key.
 *
 * Opens a `connect()` call when the first component subscribes to this effect, and closes it when
 * the last component unsubscribes. This ensures only ONE connection per page key, regardless of how
 * many components use `usePresence`.
 */
export const $presenceConnectionEffect = atomFamily((key: string) => {
	const effect = atomEffect((get) => {
		const connection = get($editorStateConnection(key));
		if (!connection) {
			return;
		}

		const { presence, context } = connection;
		const abortController = new AbortController();
		const connectPresence = makeMdPageConnectPresenceCommand(presence, context);

		logger.debug("Opening presence connection", { key });
		void connectPresence({ signal: abortController.signal });

		return () => {
			logger.debug("Closing presence connection", { key });
			abortController.abort();
		};
	});
	effect.debugLabel = `presenceConnectionEffect::${key}`;
	return effect;
});
